import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { LoadingContext } from "../../../../contexts/Loading/LoadingContext";
import { api } from "../../../../services/api";
import UserPage from "../UserPage";
import "../styles.css";
import { HomeContext, TemplateProps} from "../../../../contexts/Home/HomeContext";

// imagens disponiveis para templates
import thumb_default from "../../images/thumb_default.png";
import thumb_atraso from "../../images/thumb_atraso.png";
import thumb_coletas from "../../images/thumb_coletas.png";
import thumb_ocorrencias from "../../images/thumb_ocorrencias.png";
import thumb_transferencias from "../../images/thumb_transferencias.png";
import { AuthContext } from "../../../../contexts/Authentication/AuthContext";

function MouseOver(event: BaseSyntheticEvent) {
  event.target.style.cursor = "pointer";
}

const TemplatesGrid = () => {
  const { changeVisibility } = useContext(LoadingContext);
  const { hasShortToken } = useContext(AuthContext);
  const { shortToken } = useParams();
  const { addFromTemplate } = useContext(HomeContext);
  let route: string;
  const [templatesPages, setTemplatesPages] = useState<TemplateProps['content']>([]);
  const [geral, setGeral] = useState<TemplateProps[]>([]);
  const [completeRequisition, setCompleteRequisition] = useState(false);

  const [imagesList] = useState<{[chave: string]: string}>({
    thumb_default: thumb_default,
    thumb_transferencias: thumb_transferencias,
    thumb_ocorrencias: thumb_ocorrencias,
    thumb_atraso: thumb_atraso,
    thumb_coletas: thumb_coletas,
  })

  if (hasShortToken) {
    route = `/templates?short_token=${shortToken}`;
  } else {
    route = `/templates`;
  }

  useEffect(() => {
    changeVisibility(true);
    Promise.all([api.get(route)])
      .then(([response]: [{ data: TemplateProps[] }]) => {
        if (response.data && response.data.length > 0) {
          response.data.forEach((page: TemplateProps) => {
            templatesPages.push(page.content[0]);
          });
          setTemplatesPages(templatesPages);
          setGeral(response.data);
        }
      })
      .finally(() => {
        changeVisibility(false);
        setCompleteRequisition(true);
      });
  }, []);

  return (
    <>
      <Container id="container-templates">
        <Row>
          {completeRequisition ? (
            geral.map((page: TemplateProps, index: number) => (
              <Col key={index} xs={12} md={6} lg={4} xl={4} >
                <div className="modal-card" id={page.id} onMouseOver={MouseOver} onClick={() => addFromTemplate([page.content[0]])}>
                  <div id="modal-details">
                    <Card style={{}}>
                      <Card.Img variant="top" src={imagesList[page.image] ? imagesList[page.image] : imagesList['thumb_default'] } />
                      <Card.Body>
                        <Card.Title>{page.content[0].title}</Card.Title>
                        <Card.Text>{page.description}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                  <UserPage
                    index={index}
                    name={page.content[0].title}
                    id={page.id.toString()}
                    template={true}
                  />
                </div>
              </Col>
            ))
          ) : (
            <></>
          )}
        </Row>
      </Container>
    </>
  );
};

export default TemplatesGrid;
